// ****************************************************************************************************************************************************
// Utility to adjust lineup button layout based on container width
export function fixFeatureButton() {
  $('.featureLineupContainer').each((i, element) => {
    lineupButtonsGrid($(element));
  });
}

function lineupButtonsGrid(lineup) {
  const containerSize = lineup.width();
  const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
  const icons = buttonContainer.find('.featureLineup-social');
  const buttons = buttonContainer.find('.featureLineup-buynow');

  if (icons.width() + buttons.width() > containerSize - 20) {
    buttonContainer.addClass('column');
  }

  if (!icons.children().length) {
    icons.remove();
  }
}

// ****************************************************************************************************************************************************
// Utility function to determine whether a given URL belongs to the current domain (local) or is external
export function isLocalUrl(urlToCheck) {
  return urlToCheck !== null && urlToCheck.includes(SITEBASEURL);
}

// ****************************************************************************************************************************************************
// Utility function to add target attribute to external links

export function openNewTab(isLocal) {
  return isLocal ? '' : 'target="_blank"';
}

// ****************************************************************************************************************************************************
// Utility function to improve custom burger toggle button

export function toggleMobileMenu() {
  const currentToggle = $(`.mobile-nav-toggle`);
  const closeToggle = $('.mobile-menu-container .close-mobile-menu');

  openMenuKeyboard();

  function openMenuKeyboard() {
    currentToggle.attr('tabindex', '0');
    currentToggle.on('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && !$('body').hasClass('mobile-menu-open')) {
        $(this).trigger('click');
        closeMenuKeyboard();
      }
    });
  }

  function closeMenuKeyboard() {
    closeToggle.attr('tabindex', '0');
    closeToggle.focus();

    closeToggle.on('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && $('body').hasClass('mobile-menu-open')) {
        $(this).trigger('click');
      }
      currentToggle.focus();
    });
  }
}

// ****************************************************************************************************************************************************
// Prevents the search button from receiving focus

export function fixSearchFocus() {
  $('.header .searchSubmitButton').attr('tabindex', '-1');
}

// ****************************************************************************************************************************************************
// Utility to Customize Sign Up Widget

export function modifySignup() {
  const signupWidget = $('.tier-five .emailSignup');

  signupWidget.each(function () {
    const $this = $(this);
    const inputField = $this.find('.emailInputField');
    const submitButton = $this.find('.emailInputSubmit');

    $this.find('.emailSignupText').replaceWith(`
      <div class="emailSignupTextContainer">       
        <h6>Become A Member!</h6>
      </div>`);

    $(inputField.add(submitButton)).wrapAll('<div class="signup-form"></div>');

    inputField
      .find('.inputFieldTextbox')
      .val('')
      .attr('placeholder', 'Email Address')
      .attr('aria-label', 'Enter Email Address');

    submitButton.find('.emailSubmitButton').text('Sign Up');

    $this
      .find('.emailSignupTextContainer, .signup-form')
      .wrapAll('<div class="emailSignupLeft"></div>');

    $this.append('<div class="emailSignupRight"></div>');
  });
}

// ****************************************************************************************************************************************************
// Utility to remove focus when cart is empty

export function removeFocusCart() {
  const cartLink = $('.header .cartMenuLink');
  const href = (cartLink.attr('href') || '').trim();

  const isNavigable = href.startsWith('http');

  if (!isNavigable) {
    cartLink.attr('tabindex', '-1');
  }
}

// ****************************************************************************************************************************************************
// Utility to change footer layout for mobile

export function footerLayout() {
  const footerNavigation = $('.footer-navigation');
  const footerLogoGrid = $('.logo-grid');
  const footerContactInfo = $('.footer-contact-info-container');

  if (globalThis.matchMedia('(max-width: 900px)').matches) {
    footerNavigation.insertAfter(footerLogoGrid);
  } else {
    footerNavigation.insertAfter(footerContactInfo);
  }
}
